import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from "framer-motion";
import SectionHeading from '../common/SectionHeading';
import { skillsData } from '../../data/SkillsData';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveSection } from '../../reducers/slices/navSlice';

const Skills = () => {
  const { timeOfLastClick } = useSelector((state) => state.activeSec);
  const dispatch = useDispatch();

  const { ref, inView } = useInView({ threshold: 0.5 });

  useEffect(() => {
    if (inView && Date.now() - timeOfLastClick > 1000) {
      dispatch(setActiveSection("skills"));
    }
  }, [inView]);

  return (
    <section ref={ref} className="relative z-10 w-full flex flex-col scroll-m-20 py-20" id="skills">
      <SectionHeading text="Technical Skills" />
      
      <div className="w-[95%] max-w-[1000px] mx-auto mt-12 relative">
        {/* Subtle background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-accent-primary/20 blur-[100px] rounded-full pointer-events-none z-0"></div>

        <ul className="relative z-10 w-full flex flex-wrap justify-center gap-4">
          {skillsData.map((skill, index) => (
            <motion.li
              key={index}
              className="relative group cursor-default"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.5, ease: "easeOut" }}
              whileHover={{ scale: 1.05 }}
            >
              {/* Animated border glow on hover */}
              <div className="absolute -inset-0.5 bg-gradient-to-r from-accent-primary to-purple-500 rounded-full blur opacity-0 group-hover:opacity-50 transition duration-300"></div>
              <div className="relative flex items-center justify-center gap-3 px-6 py-3 rounded-[2rem] bg-gray-50/10 dark:bg-white/5 border border-black/10 dark:border-white/10 glass text-lg font-medium tracking-wide text-rich-black-800 dark:text-gray-200 backdrop-blur-lg transition-colors group-hover:border-black/30 dark:group-hover:border-white/20 hover:bg-white/20 shadow-sm">
                <span className="text-2xl drop-shadow-sm">{skill.icon}</span>
                <span>{skill.name}</span>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Skills;